<template>
  <span v-if="badge" class="badge artwork">{{ labeText }}</span>
</template>
<script setup>
  import { computed, defineProps } from 'vue'

  const props = defineProps({
    badge: {
      type: String,
      default: '',
    },
  })

  const labeText = computed(() => {
    if (props.badge === 'new_movie') {
      return '신작 업데이트'
    }

    if (props.badge === 'new_vod') {
      return '신규 시리즈'
    }

    return ''
  })
</script>
